import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import { post } from "common/helpers/HTTP";

import type { CsvState } from "../types";

async function parseCsvRequest(
  workspaceId: string,
  csv: string,
): Promise<Omit<CsvState, "fileName" | "mainIdentifier">> {
  const { parsed, columns, missing_data, url_columns, row_count } = await post(
    `workspaces/${workspaceId}/csv-parse`,
    { csv },
  );

  return { parsed, columns, missing_data, url_columns, row_count };
}

export default function useParseCsv() {
  const { id: workspaceId } = useSelectedWorkspaceContext();

  const { mutateAsync: parseCsv, isPending: isParsingCsv } = useMutation({
    mutationFn: ({ csv }: { csv: string }) => parseCsvRequest(workspaceId, csv),
    onError: () => toast.error("Error parsing CSV"),
  });

  return {
    parseCsv,
    isParsingCsv,
  };
}
